import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Spacer, spacerAlignItems } from 'DVWebNodeUI'
import { TvodButtonScope, TvodButton } from './tvodButton'
import { SvodButton } from './svodButton'
import { MoreSubscriptionOptionsButton } from './moreSubscriptionOptionsButton'
import { isEmpty } from '../../utils/utils'
import {
  getSvodWinnersChildren,
  getTvodWinnersChildren
} from '../../selectors/acquisitionActions'
import * as utilityClasses from '../utilityClasses.module.scss'
import { isSubscribeActionTreeRight } from '../../utils/getAcquisitionActionChildren';

const TreeBehaviour = {
  COLLAPSED: 'Collapsed',
  EXPANDED: 'Expanded'
}

type IGetSvodButtons = {
  forceDoubleHeight: boolean,
  titleId?: string,
  svodWinners?: WpsRuntime.atv.wps.SubscribeActionTreeModelProps
}
const getSvodButtons = ({
  forceDoubleHeight,
  titleId,
  svodWinners,
}: IGetSvodButtons) => {
  if (!svodWinners) {
    return []
  }
  const behaviour = svodWinners.metadata && svodWinners.metadata.behaviour

  switch (behaviour) {
    case TreeBehaviour.COLLAPSED:
      return !isSubscribeActionTreeRight(svodWinners) ? [] : [
        <MoreSubscriptionOptionsButton
          key={'MsoButton'}
          svodWinners={svodWinners}
          titleId={titleId}
          forceDoubleHeight={forceDoubleHeight}
        />
      ]
    case TreeBehaviour.EXPANDED:
      const svodButtons = getSvodWinnersChildren(svodWinners)
      return svodButtons
        .filter(action => isEmpty(action.problems))
        .map((action, idx) => (
          <SvodButton
            key={`SvodButton-${idx}`}
            svodAction={action}
            forceDoubleHeight={forceDoubleHeight}
          />
        ))
    default:
      return []
  }
}

type IGetTvodButtons = {
  tvodButtonScope: TvodButtonScope
  tvodWinners?: WpsRuntime.atv.wps.PurchaseActionTreeModel
}
const getTvodButtons = ({
  tvodWinners,
  tvodButtonScope,
}: IGetTvodButtons) => {
  const tvodWinnersChildren = getTvodWinnersChildren(tvodWinners)
  return tvodWinnersChildren.map(
    (action: WpsRuntime.atv.wps.PurchaseActionProps, idx: number) => (
      <TvodButton
        key={`TvodButton-${idx}`}
        tvodAction={action}
        scope={tvodButtonScope}
      />
    )
  )
}

export interface IAcquisitionType {
  acquisitionActions?: WpsRuntime.atv.wps.AcquisitionActionsModelProps
  titleId?: string
  tvodButtonScope: TvodButtonScope
  forceDoubleHeight: boolean
}

export const Acquisition = ({
  acquisitionActions,
  titleId,
  tvodButtonScope,
  forceDoubleHeight,
}: IAcquisitionType) => {
  if (!acquisitionActions) {
    return null
  }

  const { tvodWinners, svodWinners } = acquisitionActions

  const svodButtons = getSvodButtons({ forceDoubleHeight, titleId, svodWinners })
  const tvodButtons = getTvodButtons({ tvodWinners, tvodButtonScope })

  const allButtons = [...svodButtons, ...tvodButtons].filter(Boolean)

  return isEmpty(allButtons) ? null : (
    <Spacer className={utilityClasses.fullWidthPhablet} alignItems={spacerAlignItems.top}>
      {allButtons}
    </Spacer>
  )
}
